import React, { FC, ReactNode, ReactText } from 'react';

import GridBorder from '../../modules/grid-border/grid-border';
import Step from '../../modules/step';
import TableHeaderWrapper from '../../modules/table-header-wrapper/table-header-wrapper';
import TableWrapper from '../../modules/table-wrapper/table-wrapper';
import FormFooter from '../form-footer';

import DetailsLeft from './details-left';
import DetailsRight from './details-right';
import DetailsTop from './details-top';
import TransactionDetailsTable, {
  ITransactionDetails,
} from 'components/TransactionDetailsTable';

import './index.scss';

interface DetailContainerProps {
  infoTitle?: {
    title?: string;
    description?: string | React.ReactNode;
    status?: React.ReactNode;
    steps?: { title: string; active?: boolean }[];
  };
  leftContent?: {
    title: string;
    docTitle?: string;
    docs?: React.ReactNode[];
    detailsList: {
      title: string;
      value: string | number | ReactText | JSX.Element;
    }[][];
  };
  transactionDetails?: ITransactionDetails;
  leftComponent?: React.ReactNode;
  centralComponent?: React.ReactNode;
  rightContent?: {
    title: string;
    detailsList: { title: string; value: string | number | ReactNode }[][];
  };
  rightTopComponent?: React.ReactNode;
  rightBottomComponent?: React.ReactNode;
  title: string;
  isOrangeHader?: boolean;
  onClose: () => void;
  footer?: React.ReactNode;
  skipFooterCheck?: boolean;
}

const DetailsContainer: FC<DetailContainerProps> = ({
  onClose,
  infoTitle,
  leftContent,
  leftComponent,
  centralComponent,
  rightContent,
  rightTopComponent,
  rightBottomComponent,
  isOrangeHader,
  title,
  footer,
  transactionDetails,
  skipFooterCheck,
}) => (
  <TableWrapper>
    <div className="details">
      <div className="details__header">
        <TableHeaderWrapper
          onCloseClick={onClose}
          isOrange={isOrangeHader}
          leftContent={title}
        />
      </div>
      <div className="details__body">
        <GridBorder
          infoTitle={
            infoTitle && (
              <>
                {infoTitle?.steps && <Step steps={infoTitle.steps} />}
                <DetailsTop
                  title={infoTitle?.title}
                  description={infoTitle?.description}
                  status={infoTitle?.status}
                />
              </>
            )
          }
          leftContent={
            centralComponent ? (
              <>{centralComponent}</>
            ) : (
              (leftComponent || leftContent) && (
                <div className="details__left-container">
                  {leftComponent}
                  {leftContent && <DetailsLeft {...leftContent} />}
                  {transactionDetails && transactionDetails.fromHash && (
                    <div className="details__transaction-details-container">
                      <h2 className="text-2 details__title">
                        Детали транзакции:
                      </h2>
                      <br />
                      <TransactionDetailsTable {...transactionDetails} />
                    </div>
                  )}
                </div>
              )
            )
          }
          rightContent={
            (rightTopComponent || rightContent || rightBottomComponent) && (
              <>
                {rightTopComponent}
                {rightContent ? <DetailsRight {...rightContent} /> : null}
                {rightBottomComponent}
              </>
            )
          }
        />
      </div>
    </div>

    {footer && <FormFooter skipCheck={skipFooterCheck}>{footer}</FormFooter>}
  </TableWrapper>
);

export default DetailsContainer;
